import React from "react"
import { useTranslation } from "react-i18next"
import * as S from "./Style"
import SvgLogo from "../../../../app/assets/img/Logo-Black.svg"
import { bookingContactEmail, bookingContactMailtoHref } from "@utils/contactEmail"

const Footer: React.FC = () => {
  const { t } = useTranslation("common/footer")
  const yearDate = new Date().getFullYear()

  return (
    <S.FooterWrapper>
      <S.Content>
        <S.LogoWrapper>
          <S.Logo to="/">
            <SvgLogo aria-label={t("logoAlt")} />
          </S.Logo>

          <S.Navigation>
            <S.NavLink to={t("routes.home")}>{t("home")}</S.NavLink>
            <S.NavLink to={t("routes.about")}>{t("about")}</S.NavLink>
            <S.NavLink to={t("routes.gallery")}>{t("gallery")}</S.NavLink>
            <S.NavLink to={t("routes.testimonials")}>{t("testimonials")}</S.NavLink>
            <S.NavLink to={t("routes.availability")}>{t("availability")}</S.NavLink>
          </S.Navigation>
        </S.LogoWrapper>

        <S.ContactInfo>
          <S.Email href={bookingContactMailtoHref}>{bookingContactEmail}</S.Email>
          <S.Address>{t("address")}</S.Address>
        </S.ContactInfo>
      </S.Content>
      <S.Copyright>
        © {yearDate} Paraiso Presidential 20 |{" "}
        <a href="https://www.sor-seo.com" target="_blank" rel="noopener noreferrer" aria-label={t("creditAlt")}>
          {t("credit")}
        </a>
      </S.Copyright>
    </S.FooterWrapper>
  )
}

export default Footer
